(function () {
  function clearBodyScrollLocks() {
    if (window.bodyScrollLock) {
      window.bodyScrollLock.clearAllBodyScrollLocks();
    }
  }

  function patchModalDialog() {
    var ModalDialog = customElements.get("modal-dialog");
    if (!ModalDialog || ModalDialog.prototype.__shoppyPatched) return;

    var originalHide = ModalDialog.prototype.hide;
    ModalDialog.prototype.hide = function () {
      originalHide.call(this);
      clearBodyScrollLocks();
    };

    ModalDialog.prototype.__shoppyPatched = true;
  }

  if (customElements.get("modal-dialog")) {
    patchModalDialog();
  } else {
    customElements.whenDefined("modal-dialog").then(patchModalDialog);
  }

  function closeHeyLightModal(modal) {
    if (!modal) return;

    if (typeof modal.hide === "function") {
      modal.hide();
      return;
    }

    modal.removeAttribute("open");
    clearBodyScrollLocks();
  }

  if (!window.heylightMessageListener) {
    window.addEventListener("message", function (e) {
      if (!e.data || !e.data["heidi-action-toggle-iframe"]) return;

      closeHeyLightModal(
        document.querySelector("modal-dialog.shoppy-heylight-modal[open]"),
      );
    });
    window.heylightMessageListener = true;
  }

  // Boutique Appointment Form Modal - Open when hash is present
  function openBoutiqueAppointmentModal() {
    if (window.location.hash === "#boutique-appointment-form") {
      var modal = document.getElementById("boutique-appointment-form");
      if (modal && typeof modal.show === "function") {
        modal.show();
      }
    }
  }

  function setBoutiqueAppointmentRequestType(requestType) {
    var modal = document.getElementById("boutique-appointment-form");
    if (!modal) return;

    var titleEl = modal.querySelector(".product-popup-modal__title");
    if (titleEl && requestType) titleEl.textContent = requestType;

    var requestTypeInput = modal.querySelector(
      "#BoutiqueAppointmentRequestType",
    );
    if (requestTypeInput && requestType) requestTypeInput.value = requestType;
  }

  // Update modal title + hidden field based on trigger
  document.addEventListener("click", function (e) {
    var btn =
      e.target && e.target.closest
        ? e.target.closest(
            ".product-form__appointment-button[data-request-type]",
          )
        : null;
    if (!btn) return;
    setBoutiqueAppointmentRequestType(btn.dataset.requestType);
  });

  // Normalize phone to "+41791234567" style: keep digits and a leading "+",
  // drop the "(0)" trunk prefix in international numbers ("+33 (0)6 ...")
  function normalizePhone(value) {
    var phone = value.trim();
    var international = phone.charAt(0) === "+";
    if (international) phone = phone.replace(/\(0\)/g, "");
    var digits = phone.replace(/\D/g, "");
    return digits ? (international ? "+" : "") + digits : "";
  }

  // Window capture runs before any other submit listener (e.g. reporting-demandes)
  window.addEventListener(
    "submit",
    function (e) {
      var form = e.target;
      if (!form || form.id !== "BoutiqueAppointmentForm") return;
      var phoneInput = form.querySelector('[name="contact[phone]"]');
      if (phoneInput && phoneInput.value) {
        phoneInput.value = normalizePhone(phoneInput.value);
      }
    },
    true,
  );

  // Remove hash from URL when modal is closed
  function handleBoutiqueModalClose() {
    var modal = document.getElementById("boutique-appointment-form");
    if (!modal) return;

    // Listen to the modalClosed event dispatched by ModalDialog
    document.body.addEventListener("modalClosed", function () {
      if (window.location.hash === "#boutique-appointment-form") {
        // Remove hash from URL without triggering hashchange
        if (window.history && window.history.replaceState) {
          window.history.replaceState(
            null,
            null,
            window.location.pathname + window.location.search,
          );
        } else {
          window.location.hash = "";
        }
      }
    });

    // Also use MutationObserver as fallback
    var observer = new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        if (
          mutation.type === "attributes" &&
          mutation.attributeName === "open"
        ) {
          if (
            !modal.hasAttribute("open") &&
            window.location.hash === "#boutique-appointment-form"
          ) {
            // Small delay to ensure modal is fully closed
            setTimeout(function () {
              if (window.history && window.history.replaceState) {
                window.history.replaceState(
                  null,
                  null,
                  window.location.pathname + window.location.search,
                );
              } else {
                window.location.hash = "";
              }
            }, 100);
          }
        }
      });
    });

    observer.observe(modal, {
      attributes: true,
      attributeFilter: ["open"],
    });
  }

  // Initialize boutique appointment modal
  function initBoutiqueAppointmentModal() {
    openBoutiqueAppointmentModal();
    handleBoutiqueModalClose();
  }

  // Check on page load
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initBoutiqueAppointmentModal);
  } else {
    initBoutiqueAppointmentModal();
  }

  // Check on hash change
  window.addEventListener("hashchange", openBoutiqueAppointmentModal);
})();
